import * as React from 'react';
import * as Loadable from 'react-loadable';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { DhlLayoutComp } from '@page/layout';
import { MessageTemplatePage } from '@page/message-template/index';
import { UserProps } from '@interface/index';
import { ContentLoading } from '@component/index';
import { ChannelConfigMetaPage } from '@page/channel-config-meta';
import { ExternalTryItNow } from '@component/try-it-now/external';

export enum ExceptionCodes {
  forbidden = 403,
  notFound = 404,
  internalServerError = 500
}
export const history = createBrowserHistory();

const Login = Loadable({
  loader: () => import('../page/main/login'),
  loading: () => <div />
});
const Register = Loadable({
  loader: () => import('../page/main/register'),
  loading: () => <div />
});
const FindPassword = Loadable({
  loader: () => import('../page/main/find-password'),
  loading: () => <div />
});
const EmailValidation = Loadable({
  loader: () => import('../page/account/validation'),
  loading: () => <div />
});
const WechatAuth = Loadable({
  loader: () => import('../page/main/wechat-auth'),
  loading: ContentLoading
});
const AddOrg = Loadable({
  loader: () => import('../page/org/add-org'),
  loading: ContentLoading
});
const Exception = Loadable({
  loader: () => import('../page/main/exception'),
  loading: ContentLoading
});
const WechatCallback = Loadable({
  loader: () => import('../page/account/wechat-callback'),
  loading: ContentLoading
});

const ThirdParty = Loadable({
  loader: () => import('../page/agent/cloneable'),
  loading: ContentLoading
});

const ViewLog = Loadable({
  loader: () => import('../page/main/view-log'),
  loading: ContentLoading
});

export interface RouteCompProps {
  routes: JSX.Element[];
  userData: UserProps;
  updateUserData: (userData: UserProps) => void;
}

export const RouteComp = (props: RouteCompProps) => {
  const isLogin =
    props.userData &&
    props.userData.user_id &&
    props.userData.state === 'approve';

  const redirectUrl = encodeURIComponent(window.location.pathname + window.location.search);

  return (
    <Router history={history as any}>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/copilot_login" component={Login} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/find-password" component={FindPassword} />
        <Route exact path="/email-verify" component={EmailValidation} />
        <Route
          exact
          path="/wechat-auth"
          render={(compProps: any) => <WechatAuth {...compProps} />}
        />
        <Route
          exact
          path="/wechat-callback"
          render={(compProps: any) => <WechatCallback {...compProps} />}
        />
        <Route
          exact
          path="/403"
          render={() => <Exception status={ExceptionCodes.forbidden} />}
        />
        <Route
          exact
          path="/404"
          render={() => <Exception status={ExceptionCodes.notFound} />}
        />
        <Route
          exact
          path="/500"
          render={() => (
            <Exception status={ExceptionCodes.internalServerError} />
          )}
        />
        <Route
          exact
          path="/error"
          render={() => (
            <Exception status={ExceptionCodes.internalServerError} />
          )}
        />
        <Route
          exact
          path="/try_it_now"
          render={(compProps: any) => <ExternalTryItNow {...compProps} />}
        />
        {!isLogin && (
          <Redirect exact to={window.location.pathname === '/copilot' ? `/copilot_login?redirect=${redirectUrl}` : `/login?redirect=${redirectUrl}`} />
        )}
        <Route
          exact
          path="/view-log"
          render={(compProps: any) => <ViewLog {...compProps} />}
        />
        <Route
          exact
          path="/message_temp"
          render={() => {
            return <MessageTemplatePage />;
          }}
        />
        <Route
          exact
          path="/channel_config_meta"
          render={() => {
            return <ChannelConfigMetaPage />;
          }}
        />
        <Route
          path="/"
          render={compProps => (
            <DhlLayoutComp
              match={compProps.match}
              history={compProps.history}
              location={compProps.location}
              content={
                <Switch>
                  <Redirect exact from="/" to="/org" />
                  {props.routes}
                  <Redirect push={true} to={{ pathname: '/404' }} />
                </Switch>
              }
            />
          )}
        />
      </Switch>
    </Router>
  );
};
